/**
 * The outside services the product depends on, named once.
 *
 * These names were written twice, in the probes that check each service and
 * again in the panel that lists them, which is two places to rename and one
 * chance to forget. The probes and the panel now read the same record, so a
 * name is a name everywhere it appears.
 */
export const SERVICE_LABELS = {
  smtp: 'Email',
  dataforseo: 'Search',
  dmca: 'DMCA.com',
  cloudflare: 'Cloudflare',
  s3: 'Storage',
  stripe: 'Payments',
  slack: 'Slack',
  whatsapp: 'WhatsApp',
  imageWorker: 'Image match',
  whois: 'WHOIS',
} as const;

export type ServiceId = keyof typeof SERVICE_LABELS;

/**
 * The service label with any trailing "(vendor)" stripped. Labels are short now,
 * so this is usually a no-op, but it stays so an unknown id falls back cleanly
 * and a future bracketed label does not leak into a heading.
 */
export function serviceShortLabel(id: ServiceId): string {
  // Callers can reach this with a string cast to ServiceId (a DB key prefix that
  // is not actually a known service); fall back to the id itself instead of
  // reading .replace off undefined.
  return (SERVICE_LABELS[id] ?? id).replace(/\s*\([^)]*\)$/, '');
}
